import { useEffect } from "react"

import EventEmitter from "src/EventEmitter"

import { gql, useClient, useQuery } from "hooks/urql"

export type SessionConfig = {
  persistSessionTranscript: boolean
  tutorCaptionsEnabled: boolean
  copilotEnabled: boolean
  shouldTranslateAudioForTutor: boolean
  viewerAudioPlaybackRate: number
  viewerLiveTranslationLanguageCode: string | null
}

// "Session config" refers to those session attributes which directly impact the way the cloudroom behaves.
// When any of these attributes change, an immediate cloudroom update is required.
const useCloudroomSessionConfig = (sessionId: string) => {
  const client = useClient()
  const [result, refetch] = useQuery({
    query: cloudroomSessionConfigQuery,
    client,
    variables: { id: sessionId },
  })

  useEffect(() => {
    const onSessionConfigUpdated = () => {
      refetch({ requestPolicy: "network-only" })
    }

    EventEmitter.subscribe("session_config_updated", onSessionConfigUpdated)
    return () => {
      EventEmitter.unsubscribe("session_config_updated", onSessionConfigUpdated)
    }
  }, [refetch])

  const sessionConfig: SessionConfig | undefined = result.data?.airtutorsSession

  return { sessionConfig, result }
}

const cloudroomSessionConfigQuery = gql`
  query CloudroomSessionConfig($id: ID!) {
    airtutorsSession(id: $id) {
      id
      persistSessionTranscript
      tutorCaptionsEnabled
      copilotEnabled
      viewerAudioPlaybackRate
      viewerLiveTranslationLanguageCode
    }
  }
`

export default useCloudroomSessionConfig
